/******************************
 FUNZIONI EVENTO GTM
 *****************************/

var GTM = function() {

    let items = {};
    let ecommerceEvents = [
        "view_item_list",
        "view_item",
        "select_item",
        "view_promotion",
        "select_promotion",
        "add_to_cart",
        "add_to_wishlist",
        "remove_from_cart",
        "view_cart",
        "begin_checkout",
        "add_payment_info",
        "add_shipping_info",
        "purchase",
        "refund"
    ];

    let isEcommerceEvent = function (event) {

        return ecommerceEvents.indexOf(event) !== -1;

    };

    let sendEvent = function (name, params) {

        let payload = {
            event: name
        };

        window.dataLayer = window.dataLayer || [];

        if(isEcommerceEvent(name)) { // se devo pushare un evento ecommerce Google consiglia di resettare il dataLayer
            window.dataLayer.push({ ecommerce: null });
            payload = $.extend(payload, {
                ecommerce: {
                    currency: getCurrency(name),
                    value: +parseFloat(getPriceTotal(name)).toFixed(2),
                    items: getItems(name)
                }
            });
        }

        payload = $.extend(payload, params || {});

        window.dataLayer.push(payload);

        unsetItemsOfEvent(name);

    };

    let getItems = function (event) {

        return items[event];

    };

    let pushItemToEvent = function (event, params) {

        if(!items.hasOwnProperty(event)) {

            items[event] = [];

        }

        items[event].push(params);

    };

    let unsetItemsOfEvent = function (event) {

        if(items.hasOwnProperty(event)) {
            items[event] = [];
        }

    };

    let sumFunction = function (a, b)
    {
        return a + b;
    }

    let getPriceTotal = function(event) {

        let total = 0;

        items[event].forEach(function(item) {
            total = sumFunction(total, (item.price - item.discount))
        })

        return total;

    }

    let getCurrency = function (event) {

        return items[event][0].currency || 'EUR';

    }

    return {

        send: function (event, params) {

            sendEvent(event, params);

        },

        pushItemToEvent: function (event, params) {

            pushItemToEvent(event, params);

        }
    }
}();
